import { render } from "./Horse.vue?vue&type=template&id=48b6e68f"
import script from "./Horse.vue?vue&type=script&lang=js"
export * from "./Horse.vue?vue&type=script&lang=js"

import "./Horse.vue?vue&type=style&index=0&id=48b6e68f&lang=css"

import exportComponent from "/Users/iomac/Progetti/equiup/equiupmaneggi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__